module.exports = __webpack_public_path__ + "static/img/quality03.ab51dea.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/quality03.jpg
// module id = VCr4
// module chunks = 1